<template>
  <div class="payment-schedule secondary" ref="paymentSchedule">
    <div class="section-header" ref="sectionHeader">
      <v-layout row>
        <v-flex lg6>
          <div class="section-name">{{ layoutSetting.section.caption }}</div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <i icon class="fad fa-sync-alt" @click="loadPPSLoadHistory" slot="activator"
                 v-bind="attrs"
                 v-on="on">
              </i>
            </template>
            <span>Refresh Loan History</span>
          </v-tooltip>
        </v-flex>
        <v-flex lg6>
          <div class="section-action" @mouseover="showTooltip">
            <v-tooltip left max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <i class="fad fa-lightbulb text-warning" v-bind="attrs" v-on="on"></i>
              </template>
              <div v-html="toolTipData"></div>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="section-table" ref="sectionTable">
      <arb-simple-table
        :desserts="loanHistoryArray"
        :header="layoutSetting.sectionFields"
        :color="$vuetify.theme.themes.light.secondary"
        height="130"
        reverseIndex="true"
        clickAction="true"
        @row-clicked-event="tableRowClickHandler"
      ></arb-simple-table>
    </div>
  </div>
</template>

<script>
import { ProcessingApi } from '@/api/pandaria'
import { DataType, Tool, Cache, Crypto } from '@/util/index'

const tool = new Tool()
const cache = new Cache()
export default {
  name: 'LoanHistory',
  props: {
    layoutSetting: Object,
    loan: Object,
    toolTipData: String
  },
  data () {
    return {
      loanHistoryMap: {},
      loanHistoryArray: [],
      renderTool: tool,
      dataType: DataType,
      loanPhaseEnum: DataType.LoanPhaseEnum,
      loanStatusEnum: DataType.LoanStatus
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    advanceNumber () {
      return this.loanHistoryMap.loanHistory.length
    }
  },
  mounted () {
    this.$eventBus.$on('get-latest-slave-detail-event', target => {
      this.loadPPSLoadHistory()
    })
    this.$eventBus.$on('updateSignStatus', target => {
      this.loadPPSLoadHistory()
    })
  },
  methods: {
    async loadPPSLoadHistory () {
      this.store.commit('setPPSFirstValidSlaveLoan', null)
      this.store.commit('setPPSFirstValidSlaveLoanId', null)
      await ProcessingApi.getLoanHistoryByParentLoanId({ parentLoanId: this.loanId }, this.getLoanHistoryByParentLoanIdCallBack)
    },
    getLoanHistoryByParentLoanIdCallBack (result) {
      this.loanHistoryArray = result
      this.store.commit('setLoanHistoryData', result)
      let unVoid = 0
      this.loanHistoryArray.map(item => {
        if (item.loanStatus === DataType.LoanStatus.VOIDED.value || item.loanStatus === DataType.LoanStatus.MANUALLY_VOIDED.value) {
          item.class = 'text-grey font-italic'
        } else {
          unVoid++
          if (unVoid > 1) {
            item.class = 'text-grey font-italic'
          } else if (unVoid === 1) {
            this.store.commit('setPPSFirstValidSlaveLoan', item)
            this.store.commit('setPPSFirstValidSlaveLoanId', item.loanId)
          }
        }
      })
      this.store.commit('setPPSLatestSlaveLoan', result[0])
      const loanId = result[0].loanId
      this.store.commit('setPPSCurrentAppId', loanId)
      this.store.commit('setCurrentLoan', result[0])
      this.store.commit('setPPSLatestAppId', loanId)
      this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: loanId })
    },
    tableRowClickHandler (item) {
      let prefix = ''
      let flag = false
      this.store.commit('setSendEmailLoanId', item.loanId)
      const loanStatus = item.loanStatus
      if (tool.isNotEmpty(loanStatus)) {
        for (const item in this.loanStatusEnum) {
          const enumItem = this.loanStatusEnum[item]
          if (loanStatus === enumItem.value) {
            if (tool.isNotEmpty(enumItem.prefix)) {
              flag = true
              prefix = enumItem.prefix
            }
            break
          }
        }
      }

      if (!flag) {
        const phase = item.phase
        for (const item in this.loanPhaseEnum) {
          if (phase === this.loanPhaseEnum[item].value) {
            prefix = this.loanPhaseEnum[item].abbr
          }
        }
      }

      const currentPath = this.$route.path
      if (currentPath.includes(prefix)) {
        this.store.commit('setPPSCurrentAppId', item.loanId)
        this.store.commit('setCurrentLoan', item)
        this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: item.loanId, loan: item })
        // this.$emit('changeSlaveLoanId', item)
      } else {
        if (prefix === DataType.LoanPhaseEnum.LOAN_ORIGINATION.abbr) {
          cache.setSessionLoanId(Crypto.encrypt(this.loanId))
          if (this.$route.path.includes('/pre-origination/application') && !this.$route.path.includes('/queue')) {
            this.reload()
          } else {
            this.$router.replace('/pre-origination/application')
          }
        } else {
          this.$router.push('/{0}/application/{1}'.format(prefix, Crypto.encrypt(this.loanId)))
        }
      }
    },
    showTooltip () {
      this.$eventBus.$emit('showTooltips', 'ELL_SUBSEQUENT_ADVANCES_EXPLANATION')
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-schedule {
  background: #F5F5F5;
  padding: 20px 20px 0 20px;
  margin-top: 0 !important;
  .section-header {
    margin-bottom: -15px;
    padding-top: 12px;
    .flex {
      padding: 0 12px !important;
      .section-name {
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        display: inline-block;
        margin-right: 10px;
      }
      .section-action {
        text-align: right;
        font-size: 14px;
      }
    }
  }
  .section-table {
    margin-top: 10px;
  }
}
</style>
